import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import Markdown from "markdown-to-jsx";
import { useCart, useCartActions, useItemCount } from "@/common/Contexts/CartContext";
import useDebounce from "@/common/hooks/useDebounce";
import { Icon } from "@syarahtech/ui";
import useHelpers from "@hooks/useHelpers";
var CartItemRow = function CartItemRow(_ref) {
  var block = _ref.block;
  var _useCartActions = useCartActions(),
    updateQuantity = _useCartActions.updateQuantity,
    removeItem = _useCartActions.removeItem;
  var _block$content = block.content,
    id = _block$content.id,
    image = _block$content.image,
    sub_title = _block$content.sub_title,
    badge = _block$content.badge,
    max_count = _block$content.max_count,
    price = _block$content.price;
  var count = useItemCount(id);
  var decrement = function decrement() {
    if (count <= 1) removeItem(id);else updateQuantity(id, count - 1);
  };
  var increment = function increment() {
    if (count < max_count) updateQuantity(id, count + 1);
  };
  var _useState = useState(String(count)),
    draft = _useState[0],
    setDraft = _useState[1];
  var debouncedDraft = useDebounce(draft, 500);

  // sync local draft when count changes from outside (+/- buttons, clamp)
  useEffect(function () {
    setDraft(String(count));
  }, [count]);

  // commit debounced keyboard input
  useEffect(function () {
    var parsed = debouncedDraft === "" ? 0 : parseInt(debouncedDraft, 10);
    if (Number.isNaN(parsed) || parsed === count) return;
    if (parsed <= 0) removeItem(id);else updateQuantity(id, Math.min(parsed, max_count));
  }, [debouncedDraft]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 px-4 py-4 border-b border-[#F0F2F5] last:border-b-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative flex-shrink-0 w-[76px] h-[74px] rounded-lg overflow-visible"
  }, badge && /*#__PURE__*/React.createElement("span", {
    className: "absolute -top-1 -start-1 z-10 bg-[#FEEAEA] border-soild border-[#FFDBDB] text-[#EC6234] text-[10px] font-bold rounded-[4px] p-2 leading-none"
  }, badge), /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: block.title,
    className: "w-full h-full object-contain rounded-xl bg-[#F4F6FB] p-2"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col gap-0.5 min-w-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[12px] text-[#8A97AA] leading-none"
  }, block.title), /*#__PURE__*/React.createElement(Markdown, {
    className: "text-[14px] font-bold text-[#1B2035] leading-snug"
  }, sub_title)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-baseline justify-end gap-1.5 mt-0.5"
  }, /*#__PURE__*/React.createElement(Markdown, {
    key: price.original_formatted,
    className: "text-[12px] text-[#A0A9B8] strike-adjust-wrap"
  }, price.original_formatted), /*#__PURE__*/React.createElement(Markdown, {
    key: price.current_formatted,
    className: "text-[18px] font-bold text-[#1B2035]"
  }, price.current_formatted)), /*#__PURE__*/React.createElement("div", {
    className: " mt-4 flex items-center justify-end w-fit rounded border border-solid border-[#E6E9EF] overflow-hidden flex-shrink-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center bg-white cursor-pointer px-1 leading-none ",
    onClick: increment,
    "aria-label": "add"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add",
    className: "text-[#0D0DB5]",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("input", {
    type: "number",
    inputMode: "numeric",
    className: "text-[12px] font-bold text-[#020202] w-[35px] min-w-[32px]  h-[30px] text-center bg-[#F4F5F8] border-none  outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
    value: draft,
    onChange: function onChange(e) {
      return setDraft(e.target.value);
    },
    "aria-label": "quantity"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center bg-white cursor-pointer px-1 leading-none ",
    onClick: decrement,
    "aria-label": "remove"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--remove",
    className: "text-[#0D0DB5]",
    width: 4,
    height: 4
  })))));
};
var OilCartItems = function OilCartItems() {
  var _useCart = useCart(),
    cartData = _useCart.cartData,
    isSyncing = _useCart.isSyncing;
  var itemsBlock = cartData === null || cartData === void 0 ? void 0 : cartData.find(function (b) {
    return b.component_type === "cart_items";
  });
  if (!itemsBlock) return null;
  var header = itemsBlock.content.find(function (b) {
    return b.component_type === "cart_header";
  });
  var oilItems = itemsBlock.content.filter(function (b) {
    return b.component_type === "cart_item_oil";
  });
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white md:rounded-2xl border border-[#E9EEF5] shadow-sm overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-4 py-4 border-solid border-b border-[#F0F2F5]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-bold text-[#1B2035]"
  }, itemsBlock.title), header && /*#__PURE__*/React.createElement("span", {
    className: "text-sm text-[#8A97AA]"
  }, header.content.sub_title)), header && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if (isSyncing) return;
      navigateToHard(header.content.cta_link);
    },
    "aria-disabled": isSyncing,
    className: "text-sm font-semibold text-primary-new no-underline flex items-center gap-1 ".concat(isSyncing ? "opacity-50 cursor-not-allowed pointer-events-none" : "cursor-pointer hover:underline")
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add",
    width: 4,
    height: 4,
    className: "text-primary-new"
  }), header.content.cta_label)), oilItems.map(function (block) {
    return /*#__PURE__*/React.createElement(CartItemRow, {
      key: block.id,
      block: block
    });
  }));
};
export default OilCartItems;